var _path, _path2, _line;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcScrollLeft(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15584 6.39669C3.76531 6.78721 3.76531 7.42038 4.15584 7.8109L8.79344 12.4485C9.01562 12.6707 9.37585 12.6707 9.59803 12.4485C9.8202 12.2263 9.8202 11.8661 9.59803 11.6439L5.765 7.8109C5.37447 7.42038 5.37447 6.78721 5.765 6.39669L9.59803 2.56366C9.82021 2.34148 9.82021 1.98126 9.59803 1.75908C9.37585 1.5369 9.01563 1.5369 8.79345 1.75908L4.15584 6.39669Z",
    fill: "#0859A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5747 14C0.257302 14 3.37411e-08 13.7427 7.53629e-08 13.4253L1.73335e-06 0.781889C1.77497e-06 0.46449 0.257304 0.207189 0.574702 0.207189C0.892101 0.207189 1.1494 0.464491 1.1494 0.781889L1.1494 13.4253C1.1494 13.7427 0.892099 14 0.5747 14Z",
    fill: "#0859A4"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    y1: 7.10718,
    x2: 16.5,
    y2: 7.10718,
    stroke: "#0859A4",
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcScrollLeft);
export default __webpack_public_path__ + "static/media/ic_scroll_left.f77a8fe2.svg";
export { ForwardRef as ReactComponent };